export const TYPES = {
  MonitoringSystemRepository: Symbol.for('MonitoringSystemRepository'),
  MonitoringSystemUseCases: Symbol.for('MonitoringSystemUseCases'),
};
